import { createAction, props } from '@ngrx/store';

export interface ExportRequest {
  exportId: number;
  jobId: number;
  jobTitle: string;
  filename?: string;
  downloadUrl?: string;
  creationTime?: string;
}

export const requestExport = createAction(
  '[ExportDownloads/API] Request Export',
  props<{ jobId: number; jobTitle: string; applicationIds?: number[] }>()
);

export const requestExportSuccess = createAction(
  '[ExportDownloads/API] Request Export Success',
  props<{ exportId: number; jobId: number; jobTitle: string }>()
);

export const requestExportFailure = createAction(
  '[ExportDownloads/API] Request Export Failure',
  props<{ error: unknown }>()
);

export const exportReady = createAction(
  '[ExportDownloads/WebSocket] Export Ready',
  props<{
    exportId: number;
    jobId: number;
    filename: string;
    downloadUrl: string;
    creationTime?: string;
  }>()
);

export const exportFailed = createAction(
  '[ExportDownloads/WebSocket] Export Failed',
  props<{ exportId: number; jobId: number; error?: string }>()
);

export const removeExport = createAction(
  '[ExportDownloads] Remove Export',
  props<{ exportId: number }>()
);

export const openDownloadsDropdown = createAction(
  '[ExportDownloads] Open Downloads Dropdown'
);

export const closeDownloadsDropdown = createAction(
  '[ExportDownloads] Close Downloads Dropdown'
);

export const updateExportCreationTime = createAction(
  '[ExportDownloads] Update Export CreationTime',
  props<{ exportId: number; creationTime: string }>()
);

export const loadExportDetails = createAction(
  '[ExportDownloads/API] Load Export Details',
  props<{ exports: ExportRequest[] }>()
);

export const syncPendingExports = createAction(
  '[ExportDownloads/API] Sync Pending Exports'
);

export const pruneExpiredExports = createAction(
  '[ExportDownloads] Prune Expired Exports',
  props<{ ttlDays?: number }>()
);
